import type { MenteeMentorCareerTrack } from './MenteePortalService';

type Props = {
    tracks: MenteeMentorCareerTrack[];
    specificAreas: string | null;
};

/**
 * Block styling for the "Can mentor you in" list. The palette cycles so any number of real
 * tracks renders consistently — the blocks used to be three hardcoded placeholder tracks.
 */
const TRACK_STYLES = [
    { bg: 'bg-primary', text: 'text-primary', icon: '📊' },
    { bg: 'bg-success', text: 'text-success', icon: '🚀' },
    { bg: 'bg-info', text: 'text-info', icon: '🤖' },
    { bg: 'bg-warning', text: 'text-warning', icon: '🎯' },
];

const MenteeMyMentorTracks = ({ tracks, specificAreas }: Props) => {
    const named = (tracks || []).filter((track) => track.name && String(track.name).trim() !== '');
    const areas = specificAreas?.trim() || '';

    return (
        <div className="col-md-6">
            <div className="card border-0 shadow-sm rounded-3">
                <div className="card-header bg-white border-bottom border-light-subtle p-3">
                    <h6 className="fw-bold mb-0 text-dark">Career Tracks &amp; Expertise</h6>
                </div>
                <div className="card-body p-3">
                    <div className="small fw-semibold text-secondary mb-2">Can mentor you in:</div>

                    {named.length > 0 ? (
                        <div className="d-flex flex-column gap-2">
                            {named.map((track, index) => {
                                const style = TRACK_STYLES[index % TRACK_STYLES.length];
                                return (
                                    <div
                                        key={track.id}
                                        className={`d-flex align-items-start gap-2 p-2 ${style.bg} bg-opacity-10 rounded-3`}>
                                        <span className="fs-5" aria-hidden="true">
                                            {style.icon}
                                        </span>
                                        <div>
                                            <div className={`fw-bold ${style.text} font-13`}>{track.name}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <p className="mmentor-empty">No career tracks listed yet.</p>
                    )}

                    <div className="mt-3">
                        <div className="small fw-semibold text-secondary mb-1">Expertise</div>
                        {areas ? (
                            <p className="text-secondary small mb-0">{areas}</p>
                        ) : (
                            <p className="mmentor-empty mb-0">No specific expertise areas added yet.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenteeMyMentorTracks;
